/**
 * Format price with currency symbol
 * @param {number} price - The price to format
 * @param {string} currency - The currency symbol (default: '$')
 * @returns {string} Formatted price
 */
export const formatPrice = (price, currency = '$') => {
    return `${currency}${price}`;
};

/**
 * Truncate text to specified length
 * @param {string} text - The text to truncate
 * @param {number} length - Maximum length
 * @returns {string} Truncated text
 */
export const truncateText = (text, length = 100) => {
    if (text.length <= length) return text;
    return `${text.slice(0, length)}...`;
};

/**
 * Generate class names conditionally
 * @param {Object} classes - Object with class names as keys and conditions as values
 * @returns {string} Combined class names
 */
export const classNames = (classes) => {
    return Object.entries(classes)
        .filter(([_, condition]) => condition)
        .map(([className]) => className)
        .join(' ');
};

/**
 * Check if feature is included in plan
 * @param {Object} plan - The pricing plan
 * @param {string} feature - The feature to check
 * @returns {boolean} Whether feature is included
 */
export const isFeatureIncluded = (plan, feature) => {
    return plan.features[feature] || false;
};

/**
 * Format date to readable string
 * @param {Date|string} date - The date to format
 * @returns {string} Formatted date
 */
export const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}; 